import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { Card, CardBody, CardHeader, Container } from "shards-react";
import BarChart from "./BarChart";
import Timeline from "./Timeline";
import { Timeline2 } from "./Timeline2";

const mapState = (state, ownProps) => ({
  user: state.firebase.profile,
  sectors: state.firebase.ordered.sectors,
  complaints: state.firestore.ordered.complaints,
  //graphData: state.firebase.ordered.graphData
});

const actions = {};

class GraphDashboard extends Component {
  render() {
    return (
      <Container fluid className="p-3">
        <Card>
          <CardBody>
            <Timeline2 />
          </CardBody>
        </Card>
      </Container>
    );
  }
}

export default compose(connect(mapState, actions))(GraphDashboard);
